import { SERVER } from "../constants";
import { HttpClient, SaveImage, SaveFile } from "../utils/requests";
import { MAP_URL } from "../constants/urls";
import { fixCreateProductCategoryId } from "../panels/productCategory/productCategoryMapper";
import { fixCreateProductId } from "../panels/product/productMapper";
import { fixCreateAdminUsersId } from "../panels/adminUsers/adminUsersMapper";
import { fixCreateBranchId } from "../panels/branch/branchMapper";
import { fixCreateNeedId } from "../panels/needs/needMapper";
import { fixCreateNeedCategoryId } from "../panels/needCategory/needCategoryMapper";
import { fixCreateUnitId } from "../panels/essentials/unit/unitMapper";
import { fixCreateId } from "../panels/essentials/unitProcessor/unitProcessorMapper";
import { fixCreateStatusId } from "../panels/essentials/status/statusMapper";
import { fixCreateStatusLoadingId } from "../panels/essentials/statusLoading/statusLoadingMapper";
import { fixCreateLoadingRequestId } from "../panels/loadingRequest/loadingRequestMapper";
import { fixCreateWhatsappId } from "../panels/whatsapp/whatsappMapper";
import { fixCreateCustomerId } from "../panels/crm/customer/customerMapper";
import { fixCreateContactId } from "../panels/crm/contact/contactMapper";



import { fixCreateReportId } from "../panels/report/reportMapper";
import { fixCreatePreferCallId } from "../panels/essentials/preferCall/preferCallMapper";
import { fixCreateStatusCallId } from "../panels/essentials/statusCall/statusCallMapper";
import { fixCreatePackageId } from "../panels/essentials/package/packageMapper";
import { fixCreateOrderTypeId } from "../panels/essentials/orderType/orderTypeMapper";
import { fixCreateCustomerCategoryId } from "../panels/crm/essentials/customerCategory/customerCategoryMapper";
import { fixCreateContactCategoryId } from "../panels/crm/essentials/contactCategory/contactCategoryMapper";
import { fixCreateCustomerPriorityId } from "../panels/crm/essentials/customerPriority/customerPriorityMapper";
import { fixCreateCustomerRatingId } from "../panels/crm/essentials/customerRating/customerRatingMapper";
import { fixCreateStorageId } from "../panels/essentials/storage/storageMapper";
import { fixCreateClueId } from "../panels/crm/clue/clueMapper";
import { fixCreateReminderId } from "../panels/crm/reminder/reminderMapper";
import { fixCreateSendSMSId } from "../panels/essentials/sms/SendSMSMapper";
import { fixCreateTransactionId } from "../panels/transaction/transactionMapper";
import { fixCreateBaseUnitId } from '../panels/product/details/baseUnit/baseUnitMapper';
import { fixCreateProductUnitId } from '../panels/product/details/productUnit/productUnitMapper';
import { fixCreateRawMaterialId } from '../panels/product/details/rawMaterial/rawMaterialMapper';
import { fixCreateProductCapacityId } from "../panels/productCapacity/productCapacityMapper";
import { fixCreateEventPanelId } from "../panels/event/eventMapper";
import { fixCreateReportInputProductId } from "../panels/reportInputProducts/reportInputProductsMapper";
import { fixCreateReportProductionId } from "../panels/reportProduction/reportProductionMapper";


export async function createOne(resource, params) {
  if (params.data.pictures) {
    await SaveImage(resource, params)
  }
  if (params.data.attachfile) {
    await SaveFile(resource, params)
  }

  return HttpClient(`${SERVER}/${MAP_URL[resource]}`, {
    method: "POST",
    body: JSON.stringify(params.data),
  }).then(({ json }) => {
    if (resource === 'productCategory') {
      return fixCreateProductCategoryId(params, json);
    } else if (resource === 'product') {
      return fixCreateProductId(params, json);
    } else if (resource === 'branch') {
      return fixCreateBranchId(params, json);
    } else if (resource === 'need') {
      return fixCreateNeedId(params, json);
    } else if (resource === 'needCategory') {
      return fixCreateNeedCategoryId(params, json);
    } else if (resource === 'adminUsers') {
      return fixCreateAdminUsersId(params, json);
    } else if (resource === 'unit') {
      return fixCreateUnitId(params, json);
    } else if (resource === 'unitProcessor') {
      return fixCreateId(params, json);
    } else if (resource === 'status') {
      return fixCreateStatusId(params, json);
    } else if (resource === 'statusCall') {
      return fixCreateStatusCallId(params, json);

    } else if (resource === 'preferCall') {
      return fixCreatePreferCallId(params, json);

    } else if (resource === 'statusLoading') {
      return fixCreateStatusLoadingId(params, json);
    } else if (resource === 'report') {
      return fixCreateReportId(params, json);
    } else if (resource === 'reportProduction') {
      return fixCreateReportProductionId(params, json);
    } else if (resource === 'reportInputProduct') {
      return fixCreateReportInputProductId(params, json);

    } else if (resource === 'loadingRequest') {
      return fixCreateLoadingRequestId(params, json);
    } else if (resource === 'whatsapp') {
      return fixCreateWhatsappId(params, json);
    } else if (resource === 'customer') {
      return fixCreateCustomerId(params, json);
    } else if (resource === 'contact') {
      return fixCreateContactId(params, json);
    } else if (resource === 'package') {
      return fixCreatePackageId(params, json);
    } else if (resource === 'orderType') {
      return fixCreateOrderTypeId(params, json);
    } else if (resource === 'customerCategory') {
      return fixCreateCustomerCategoryId(params, json);
    } else if (resource === 'contactCategory') {
      return fixCreateContactCategoryId(params, json);
    } else if (resource === 'customerPriority') {
      return fixCreateCustomerPriorityId(params, json);
    } else if (resource === 'customerRating') {
      return fixCreateCustomerRatingId(params, json);
    } else if (resource === 'storage') {
      return fixCreateStorageId(params, json);
    } else if (resource === 'clue') {
      return fixCreateClueId(params, json);
    } else if (resource === 'reminder') {
      return fixCreateReminderId(params, json);
    } else if (resource === 'sendSMS') {
      return fixCreateSendSMSId(params, json);
    } else if (resource === 'transaction') {
      return fixCreateTransactionId(params, json);
    } else if (resource === 'baseUnit') {
      return fixCreateBaseUnitId(params, json);
    } else if (resource === 'productUnit') {
      return fixCreateProductUnitId(params, json);
    } else if (resource === 'rawMaterial') {
      return fixCreateRawMaterialId(params, json);
    } else if (resource === 'productCapacity') {
      return fixCreateProductCapacityId(params, json);
    } else if (resource === 'eventPanel') {
      return fixCreateEventPanelId(params, json);

    }
    return {
      data: { ...params.data, id: json.objectId },
    };
  }
  );
}